module.exports = __webpack_public_path__ + "app/img/titleBG.4617b5a5.jpg";